import { Icon } from "@phosphor-icons/react";
import Typography from "../Typography";

export type CardFieldProps =
    | {
          label: string;
          value: string;
          isHtml?: boolean;
          icon?: Icon;
      }
    | {
          label: string;
          value: number;
          isHtml: false;
          icon?: Icon;
      };

const CardField = ({ label, value, isHtml, icon: Icon }: CardFieldProps) => {
    return (
        <div className="flex items-center">
            {Icon && <Icon size={22} weight="light" className="mr-3" />}
            <div>
                <Typography component="label" variant="label-small">
                    {label}
                </Typography>
                {isHtml ? (
                    <span
                        className="block leading-[1.5rem]"
                        dangerouslySetInnerHTML={{
                            __html: value,
                        }}
                    />
                ) : (
                    <Typography component="p" variant="body-large">
                        {value}
                    </Typography>
                )}
            </div>
        </div>
    );
};

export default CardField;
